<template lang="pug">
DropdownCheckboxes(
  :label="label"
  :name="name"
  :options="userOptions"
  :value="value"
  @input="update"
  :loading="loading"
)
</template>

<script>
  import DropdownCheckboxes from '@/components/dropdown_checkboxes.vue'
  import { mapStores } from 'pinia'
  import { useUsersStore } from '@/stores/users'

  export default {
    components: {
      DropdownCheckboxes
    },

    props: {
      label: {
        type: String,
        default() { return 'Owner' }
      },
      name: {
        type: String,
        default() { return 'q[user_id_in][]' }
      },
      value: {
        type: Array,
        default() { return [] }
      }
    },

    computed: {
      ...mapStores(useUsersStore),

      userOptions() {
        return this.usersStore.allAsObject;
      },

      loading() {
        return this.usersStore.users.length === 0;
      }
    },

    mounted() {
      this.usersStore.fetchOnce();
    },

    methods: {
      update(newValue) {
        this.$emit('input', newValue);
      }
    }
  }
</script>
